import * as z from "zod";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

// Clears the tombstone git sync left when a workflow was deleted on this branch,
// bringing it back as an editable member so the next sync re-adds its directory.
export const restoreWorkflowOnBranch = mutator({
  schema: z.object({ branchId: z.string() }),
  resolve: {
    branch: { kind: "branch", from: "branchId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.branch.workflow.spaceId,
    },
  ],
  fn: async ({ tx, args: { branch } }) => {
    const members = await tx.run(
      zql.spaceBranchMembers
        .where("workflowBranchId", branch.id)
        .where("deletedAt", "IS NOT", null)
    );
    for (const member of members) {
      await tx.mutate.spaceBranchMembers.update({
        spaceBranchId: member.spaceBranchId,
        workflowId: member.workflowId,
        deletedAt: null,
      });
    }
  },
});
